
import * as Highcharts from "highcharts";
import g from "../../globals/variables";

const RealEstatePurchase = (target) => {
  // * RealEstatePurchaseCalculator.cshtml
  // * RealEstatePurchaseController.cs

  const el = {
    childrenOver6: target.querySelector("select[name=ChildrenOver6]"),
    childrenUnder6: target.querySelector("select[name=ChildrenUnder6]"),
    wages1: target.querySelector(".js-wages"),
    wages2: target.querySelector(".js-wages-spouse"),
    wageInputs: target.querySelectorAll(".js-wages input, .js-wages-spouse input"),
    maritalStatusSelect: target.querySelector("select[name=MaritalStatus]"),
    family: target.querySelector("input[name=Family]"),
    housingSelect: target.querySelector("select[name=Housing]"),
    rentalLabel: target.querySelector(".js-label-rental"),
    mortgageLabel: target.querySelector(".js-label-mortgage"),
  };

  const method = {
    init: () => {
      if (target) {
        const form = target;

        form.addEventListener("submit", (e) => {
          e.preventDefault();
          // console.log(`submitting real estate calculation `);
          method.submit(form);
        });

        el.wages1.style.display = "none";
        el.wages2.style.display = "none";
        el.mortgageLabel.style.display = "none";

        el.maritalStatusSelect.addEventListener("change", method.toggleRows);
        el.housingSelect.addEventListener("change", method.toggleLabel);
      }

      // debugging
      // method.renderChart(20, 30, document.querySelector(".highchart"));
      // document.querySelector(".js-realestate-result").style.display = "block";
    },

    submit: async (form) => {
      el.wageInputs.forEach((input) => {
        if (!input.value) {
          const inputField = input;
          inputField.value = 0;
        }
      });

      el.family.value = method.populateFamily(
        parseFloat(el.childrenUnder6.value),
        parseFloat(el.childrenOver6.value),
        parseFloat(el.maritalStatusSelect.value),
      );

      const button = form.querySelector("button[type=submit]");
      const callout = form.querySelector(".callout");
      const data = new FormData(form);
      const action = form.getAttribute("action");
      const formMethod = form.getAttribute("method");

      if (callout) callout.remove();

      button.disabled = true;
      button.classList.add("button--loading");

      // console.log(`action `, action)
      // console.log(`method `, method)
      // console.log(`data `, data);

      fetch(action, {
        method: formMethod,
        body: data,
      })
        .then(res => res.json())
        .then((response) => {
          if (response.success) {
            // console.log("Calculator response");
            method.renderMessage(form, response.result);
            // form.reset();
          } else {
            method.renderError(form, response.message, "error");
          }
          setTimeout(() => {
            button.classList.remove("button--loading");
            button.disabled = false;
          }, 150);
        })
        .catch((ex) => {
          method.renderError(form, `Server error: ${ex}`, "error");
        });
    },

    toggleLabel: (event) => {
      if (event.target.value === "1") {
        el.mortgageLabel.removeAttribute("style");
        el.rentalLabel.style.display = "none";
      } else {
        el.mortgageLabel.style.display = "none";
        el.rentalLabel.removeAttribute("style");
      }
    },

    toggleRows: (event) => {
      if (event.target.value === "1") {
        el.wages1.removeAttribute("style");
        el.wages2.style.display = "none";
      } else {
        el.wages1.removeAttribute("style");
        el.wages2.removeAttribute("style");
      }
    },

    populateFamily: (
      nSex,
      nAtjan,
      fjolsk // tegFjolskyldu )
    ) => {
      // var einn = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16];
      // var hjon = [17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32];
      //  var lookUp = [[0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3][0, 1, 2, 3, 0, 1, 2, 3, 0, 1, 2, 3, 0, 1, 2, 3][1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16]];
      const look = [5, 6, 7, 8];
      const look2 = [9, 10, 11, 12];
      const look3 = [13, 14, 15, 16];

      let nRetVal = 0;
      // console.log(nSex + ' : Sexan....');
      if (nSex === 0) {
        for (let z = 0; z < 4; z++) {
          if (nAtjan === z) {
            nRetVal = z + 1;
            break;
          }
        }
      } else if (nSex === 1) {
        for (let a = 0; a < 4; a++) {
          if (nAtjan === a) {
            nRetVal = look[a];
            break;
          }
        }
      } else if (nSex === 2) {
        for (let b = 0; b < 4; b++) {
          if (nAtjan === b) {
            nRetVal = look2[b];
            break;
          }
        }
      } else if (nSex === 3) {
        for (let c = 0; c < 4; c++) {
          if (nAtjan === c) {
            nRetVal = look3[c];
            break;
          }
        }
      }

      if (fjolsk === 2) {
        nRetVal += 16;
      }
      return nRetVal;
    },

    renderMessage: (form, result) => {
      // console.log(result);
      const resultEl = form.querySelector(".js-realestate-result");
      const chartEl = resultEl.querySelector(".highchart");

      const fields = {
        amount: [
          "HeildarTekjurFostuVerdlagiBreyting",
          "EftirSkattFyrra",
          "EftirSkattSeinna",
          "Launabreyting",
          "BarnaBaeturFyrra",
          "BarnaBaeturSeinna",
          "BarnaBreyting",
          "HusaFyrra",
          "HusaSeinna",
          "HusaBreyting",
          "HeildarTekjurFyrra",
          "HeildarTekjurSeinna",
          "TekjurEftirHusaBreyting",
          "FyrrLeiga",
          "SeinniLeiga",
          "LeigaMunur",
          "HeildarTekjurEftirHusaleiguFyrra",
          "HeildarTekjurEftirHusaleiguSeinna",
          "HeildarTekjurEftirHusaleiguBreyting",
          "HeildarTekjurFostuVerdlagiSeinna",
          "HeildarTekjurFostuVerdlagiBreyting",
        ],
        percentage: [
          "HeildarTekjurFostuVerdlagiProsenta",
          "BreytingKaupmattar",
          "EftirSkattProsenta",
          "BarnaProsenta",
          "HusaProsenta",
          "TekjurEftirHusaProsenta",
          "LeigaProsenta",
          "HeildarTekjurEftirHusaleiguProsenta",
          "ThinVerdbolga",
          "HeildarTekjurFostuVerdlagiProsenta",
          "BreytingKaupmattar",
        ],
      };

      fields.amount.forEach((field) => {
        resultEl.querySelectorAll(`[data-value=${field}]`).forEach((field2) => { // done like that cuz of multiple uses of same data-value field in markup
          const fieldEl = field2;
          fieldEl.innerHTML = result[0][field].toLocaleString().replace(/,/g, ".");
        });
      });

      fields.percentage.forEach((field) => {
        resultEl.querySelectorAll(`[data-value=${field}]`).forEach((field2) => {
          const fieldEl = field2;
          fieldEl.innerHTML = result[0][field].toLocaleString().replace(".", ",");
        });
      });

      resultEl.querySelector("[data-value=year1]").innerHTML = form.querySelector("[name=PreviousYear").value;
      resultEl.querySelector("[data-value=year2]").innerHTML = form.querySelector("[name=ThisYear").value;

      resultEl.querySelectorAll("[data-value=housingLabel]").forEach((label) => {
        const labelEl = label;
        labelEl.firstElementChild.removeAttribute("style");
        labelEl.lastElementChild.removeAttribute("style");

        if (form.querySelector("[name=Housing]").value === "0") {
          labelEl.lastElementChild.style.display = "none";
        } else {
          labelEl.firstElementChild.style.display = "none";
        }
      });

      method.renderChart(result[0].BreytingKaupmattar, result[0].HeildarTekjurFostuVerdlagiProsenta, chartEl);

      resultEl.style.display = "block";
    },

    renderError: (ele, message, type) => {
      ele.insertAdjacentHTML(
        "beforeend",
        `<div class="callout callout--${type}">${message}</div>`
      );
    },

    renderChart: (breytingKaupm, thinBreyting, container) => {
      Highcharts.chart(container, {
        chart: {
          type: "column",
        },
        colors: [g.color.blueDark, g.color.blueLight, g.color.black],
        title: {
          style: {
            fontSize: "18px",
            fontWeight: 600,
            color: g.color.blueDark,
          },
          text: window.dictionary.CRE_Results, // "Kaupmáttarbreyting",
        },
        legend: {
          enabled: true,
        },
        xAxis: {
          categories: {
            series: "name",
          },
          tickLength: 3,
          labels: {
            enabled: true,
          },
        },
        yAxis: {
          allowDecimals: false,
          title: {
            text: window.dictionary.CRE_Percentage, // "Prósenta",
          },
        },
        tooltip: {
          headerFormat: "<table>",
          pointFormat: "<tr><td style=\"padding: 2px 5px; color: {series.color};\">{series.name}: </td><td style=\"padding: 2px 5px;\"><strong> {point.y:.1f}%</strong></td></tr>",
          footerFormat: "</table>",
          shared: true,
          useHTML: true,
        },
        series: [
          {
            name: window.dictionary.CRE_Results3, // "Breyting kaupmáttar skv. Hagstofu",
            data: [breytingKaupm],
          },
          {
            name: window.dictionary.CRE_Results2, // "Þín breyting",
            data: [thinBreyting],
          },
        ],
      });
    },
  };

  method.init();
};

export default RealEstatePurchase;
